export default "__VITE_ASSET__BhdXz4IO__"